import { APPLICATION_STATUS_ACTIONS } from 'constants/application-status'

export const getProfileActivities = (activities = []) =>
  activities.filter(({ action }) =>
    [
      APPLICATION_STATUS_ACTIONS.CREATE_ACCOUNT,
      APPLICATION_STATUS_ACTIONS.COMPLETE_PROFILE,
    ].includes(action)
  ) || []
